import React from 'react';

export default function EmptyState({ title, description, action }) {
    return (
        <div className="flex flex-col items-center justify-center text-center py-[60px] px-[20px] text-[#64748B]">
            <p className="text-[14px] font-semibold text-[#0F172A] m-0 mb-[4px]">{title}</p>
            {description && <p className="text-[13px] m-0 mb-[12px] max-w-[360px] leading-relaxed">{description}</p>}
            {action}
        </div>
    );
}
